const _ = require('lodash');

const Characters = [
    {
        id: 1001,
        key: 'character_pineya',
        name: 'Pineya',
        modelName: 'Pineya',
        image: '/nfts/character/pineya.png',
        description: 'Pineya, an enigmatic assassin with a robotic arm and a sleek suit, uses his skills and high-tech gadgets to safeguard the Grove and maintain the balance between the human world and the secretive realm of the Grove.',
        type: 'character',
        price: 1200,
        is_featured: false,
        contract_address: '0xe5d1Ea7b14d613780721a091d1323Be7f36447D9',
        rarity: 'Ultra-Rare',
        limit: 125
    },
    {
        id: 1002,
        name: 'Night Raider',
        key: 'character_night_raider',
        modelName: 'Nightvision_Pine',
        image: '/nfts/character/nightvision-pine.png',
        description: 'The Night Raider pine, equipped with night vision goggles, is ready to dominate stealth missions under the cover of darkness.',
        type: 'character',
        price: 600,
        is_featured: false,
        contract_address: '0x452e6CAb3D077cE1FC951a501214Be669c130AA1',
        rarity: 'Rare',
        limit: 250,
    },
    {
        id: 1003,
        name: 'Camo Invader',
        key: 'character_camo_invader',
        modelName: 'Alien_Pine',
        image: '/nfts/character/alien-pine.png',
        description: 'The Invader pineapple, dressed in camouflage, blends stealth and otherworldly charm for a unique in-game presence.',
        type: 'character',
        price: 300,
        is_featured: false,
        contract_address: '0x034a8f897DCBE1CFAc3F29a62aB8Bf8B361EC63e',
        rarity: 'Uncommon',
        limit: 500
    },
    {
        id: 1004,
        name: 'SPS Black Tux Pineya',
        key: 'character_secret_society_black_tux',
        modelName: 'Tux_Pine',
        image: '/nfts/character/tux-pine.png',
        description: 'The Secret Society Black Tux exudes sophistication and mystery, perfect for covert operations.',
        type: 'character',
        price: 0,
        is_featured: false,
        contract_address: '0xEAD44063c0BD96CBEA29ba3105366Be268223eDC',
        rarity: 'Common',
        limit: 1000000000
    },
    // {
    //     id: 1007,
    //     name: 'Independence Pinya',
    //     key: 'character_independence_day_suit',
    //     modelName: 'Independence_Pineya',
    //     image: '/nfts/character/independence-day-suit.png',
    //     description: 'A bold Independence Day outfit with red, white, and blue accents.',
    //     type: 'character',
    //     price: 500,
    //     is_featured: false,
    //     contract_address: '0x514a97f24BD74aBF91C7b3ea1D08422FF880836B',
    //     rarity: 'Rare',
    //     is_new: true,
    //     limit: 250
    // },
    // {
    //     id: 1005,
    //     name: 'Edge Node Pineya',
    //     key: 'character_edge_node_pineya',
    //     modelName: 'Edge_Node_Pineya',
    //     image: '/nfts/character/pineya-booster.png',
    //     description: 'The Theta Edge Node skin transforms your Pineya featuring dynamic blue Theta accents and enhancing the technological aesthetic of your Theta network node.',
    //     type: 'character',
    //     price: 1500,
    //     is_featured: false,
    //     contract_address: '0x8f7a4C616C39f7D2746d2892d64e49c9c8F8F58a',
    //     rarity: 'Rare',
    //     is_exclusive: true
    // },
    {
        id: 1006,
        name: 'Secret Society Pineya',
        key: 'character_secret_society_pineya',
        modelName: 'Secret_Society_Pineya',
        image: '/nfts/character/pineya-secret-society.png',
        description: 'The Secret Society outfit is a sleek dark ensemble perfect for covert operations and blending into the shadows.',
        type: 'character',
        price: 3000,
        is_featured: false,
        contract_address: '0x1588Bceb93a71c107065CcD53396FCc9ed4FA381',
        rarity: 'Rare',
        is_exclusive: true
    },
    {
        "id": 1007,
        "key": "character_pineya_summer",
        "name": "Summer Pineya",
        "modelName": "Pine_Summer",
        "image": "/nfts/character/pineya_summer.png",
        "description": "Summer Pineya is a relaxed guardian who trades his suit for a tropical look. With a pineapple helmet, floral tank top, and retro shades, he’s ready for summer fun while still protecting the Grove and keeping the realms in balance.",
        "type": "character",
        "price": 600,
        "is_featured": true,
        "contract_address": "0xa68ea231d0ab89ebd80910c36ffd12b050ecc896",
        "rarity": "Rare",
        "limit": 250,
        "is_new": true
    },
];
const BackSwag = [
    {
        id: 3001,
        name: 'Gold Pine Skull',
        key: 'back_swag_gold_pine_skull',
        modelName: 'Skull_Bag',
        image: '/nfts/back-swag/gold-skull.png',
        description: 'The Gold Pine Skull is a mysterious artifact revered and believed to hold ancient powers that protect and sustain the Grove.',
        type: 'back_swag',
        price: 800,
        is_featured: true,
        is_new: true,
        contract_address: '0xD45673314628665E5A1275965eDbD00FD17F4D70',
        rarity: 'Ultra-Rare',
        limit: 250
    },
    {
        id: 3002,
        name: 'Mango Bag',
        key: 'back_swag_mango_bag',
        modelName: 'Mango_Bag',
        image: '/nfts/back-swag/mango-bag.png',
        description: 'The Mango bag is a whimsical plushy backpack designed to resemble a cute pineapple mango.',
        type: 'back_swag',
        price: 0,
        contract_address: '0x3824829e9234a51f3e7337Bb4d70B8DC485F8290',
        rarity: 'Common',
        limit: 1000000000
    },
    {
        id: 3003,
        name: 'Pine Ruck',
        key: 'back_swag_pine_ruck',
        modelName: 'Pineapple_Bag',
        image: '/nfts/back-swag/pineapple-bag.png',
        description: 'The Pine Ruck featured for it’s uniquely designed pineapple flair.',
        type: 'back_swag',
        price: 200,
        contract_address: '0x639C845d9E1227C3d5D28070Ec883A5BA6EbB64B',
        rarity: 'Uncommon',
        limit: 1000
    },
    {
        id: 3004,
        name: 'Silver Pine Skull',
        key: 'back_swag_silver_pine_skull',
        modelName: 'Silver_Skull_Bag',
        image: '/nfts/back-swag/silver-skull.png',
        description: 'The Silver Pine Skull is a revered artifact within the Grove thought to possess ancient powers that enhance the abilities of its guardians.',
        type: 'back_swag',
        price: 400,
        contract_address: '0x28B1390F379Ef4B216823835004fD82BBf89aB28',
        rarity: 'Rare',
        limit: 500

    },
    // {
    //     id: 3005,
    //     name: 'Edge Node Booster Pack',
    //     key: 'back_swag_edge_node_booster_pack',
    //     modelName: 'Edge_Node_Jetpack',
    //     image: '/nfts/back-swag/edge-node-booster.png',
    //     description: 'The Theta Edge Node Booster backpack is a cutting-edge, wearable device equipped with advanced boosters to enhance connectivity and computational power for Theta network nodes on the go.',
    //     type: 'back_swag',
    //     price: 2000,
    //     contract_address: '0x00409042e524F5Ee40067c2E3f57b430bf43c5b7',
    //     rarity: 'Uncommon',
    //     is_exclusive: true
    // }
];

const Weapons = [
    {
        id: 2001,
        name: 'Juicer',
        key: 'weapon_juicer',
        modelName: 'The_Juicer_Pistol',
        image: '/nfts/weapon/juicer-pistol.png',
        description: 'The Juicer pistol is a railgun that uses kinetic energy to fire high-velocity projectiles with pinpoint accuracy.',
        type: 'weapon',
        price: 150,
        contract_address: '0x2dDa7f0509b1C5fD4c49CA447d0636Cd3B022600',
        // show_remaining: true,
        remaining: 150,
        rarity: 'Uncommon',
        limit: 1500
    },
    {
        id: 2002,
        name: 'Cyber Machete',
        key: 'weapon_cyber_machete',
        modelName: 'Cyber_Machete',
        image: '/nfts/weapon/cyber-machete.png',
        description: 'The Cyber Machete features a holographic edge that enhances its cutting power, making it a formidable weapon for close range combat.',
        type: 'weapon',
        price: 600,
        contract_address: '0x07Da925C08D4b7813CBf48692230f0043F18c66C',
        // show_remaining: true,
        remaining: 100,
        rarity: 'Uncommon',
        is_featured: true,
        is_new: true,
        limit: 375
    },
    {
        id: 2003,
        name: 'T-Fury',
        key: 'weapon_t_fury',
        modelName: 'Fury_Laser_SMG',
        image: '/nfts/weapon/tfury-smg.png',
        description: 'The T-Fury is a versatile weapon that combines the ability to fire powerful energy blasts with a razor- sharp blade for close-quarters melee combat.',
        type: 'weapon',
        price: 300,
        contract_address: '0x298a1efcF87DF8cDa325a3ab457C8ed27Ca88783',
        rarity: 'Rare',
        limit: 750
    },
    {
        id: 2004,
        name: 'Axeparagus',
        key: 'weapon_axeparagus',
        modelName: 'Axeparagus',
        image: '/nfts/weapon/axeparagus.png',
        description: 'The Axeparagus is a melee weapon that blends the chopping force of a pickaxe with the flexibility of an asparagus stalk. Perfect for both harvesting and combat.',
        type: 'weapon',
        price: 75,
        contract_address: '0x21a553CB9ca6fe20492fb5202eF9dE69BffB20ac',
        rarity: 'Common',
        limit: 3000
    },
    // {
    //     id: 2007,
    //     name: 'Independence Day T-Fury',
    //     key: 'weapon_independence_day_t_fury',
    //     modelName: 'Independence_Fury_Laser_SMG',
    //     image: '/nfts/weapon/independence-fury-laser-smg.png',
    //     description: 'An Independence Day T-Fury weapon with explosive firepower and patriotic red, white, and blue detailing.',
    //     type: 'weapon',
    //     price: 300,
    //     contract_address: '0x842a9f46012AC18B83EA7eCDb68A4E62C0c3bD21',
    //     rarity: 'Rare',
    //     limit: 750,
    //     is_new: true
    // },
    // {
    //     id: 2005,
    //     name: 'Edge Node T-Fury',
    //     key: 'weapon_edge_node_t_fury',
    //     modelName: 'Edge_Node_Fury_Laser_SMG',
    //     image: '/nfts/weapon/edge-node-tfury-smg.png',
    //     description: 'The Theta Edge Node T-fury skin is a sleek and dynamic weapon with a striking blue aesthetic.',
    //     type: 'weapon',
    //     price: 1000,
    //     contract_address: '0xf61493EdC0C8918E93cCD3f47E5529AF0d20856c',
    //     rarity: 'Rare',
    //     is_exclusive: true
    // },
    {
        id: 2006,
        name: 'Secret Society T-Fury',
        key: 'weapon_secret_society_t_fury',
        modelName: 'Secret_Society_Fury_Laser_SMG',
        image: '/nfts/weapon/secret-society-tfury-smg.png',
        description: 'The Secret Society SMG is a high-tech, compact submachine gun featuring a sleek design and aesthetic stealth capabilities, perfect for covert operations.',
        type: 'weapon',
        price: 1200,
        contract_address: '0x48C32be4983bf124c17f29Cc151eA6c91185d05B',
        rarity: 'Rare',
        is_exclusive: true
    },
];

const allItems = _.flatten([
    ...Characters.sort((a, b) => a.is_featured ? -1 : 1),
    ...Weapons.sort((a, b) => a.is_featured ? -1 : 1),
    ...BackSwag.sort((a, b) => a.is_featured ? -1 : 1),
]);

const getItemById = (id) => {
    return _.find(allItems, {id});
}

const getItemByModelName = (modelName) => {
    return _.find(allItems, {modelName});
}

const getItemByKey = (key) => {
    return _.find(allItems, {key});
}

const getItemByContractAddress = (contractAddress) => {
    const lcContractAddress = contractAddress.toLowerCase();
    return _.find(allItems, (x) => {
        return x.contract_address.toLowerCase() === lcContractAddress;
    });
}

const getAllItemContractAddresses = () => {
    return allItems.map((x) => x.contract_address);
}

let CACHED_HASH = null;
const getHashOfItems = () => {
    if(CACHED_HASH){
        return CACHED_HASH;
    }
    const minId = _.min(allItems.map((x) => x.id));
    const maxId = _.max(allItems.map((x) => x.id));
    const hash = `${minId}-${maxId}-${allItems.length}`;

    CACHED_HASH = hash;

    return hash;
}

export {getHashOfItems, getItemById, getItemByContractAddress, getItemByKey, getItemByModelName, getAllItemContractAddresses};
export default allItems;
//
// const processJsonFiles = () => {
//     const fs = require('fs');
//     const path = require('path');
//
//     const createJsonFiles = (items) => {
//         for (let i = 0; i < items.length; i++) {
//             const item = items[i];
//             const metadata = {
//                 "name": item.name,
//                 "description": item.description,
//                 "image": `https://warrior.grovewars.com${item.image}`,
//                 "external_url": "https://warrior.grovewars.com",
//                 "contract_address": item.contract_address,
//                 "attributes": [
//                     {
//                         "trait_type": "Type",
//                         // Capitalize the first letter of each word of the type
//                         "value": item.type.replace('_', ' ').replace(/\b\w/g, l => l.toUpperCase())
//                     },
//                     {
//                         "trait_type": "Rarity",
//                         "value": item.rarity
//                     }
//                 ]
//             }
//             const json = JSON.stringify(metadata, null, 4);
//             const fileName = item.name.toLowerCase().replace(/ /g, '_').replace(/-/g, '_');
//             const typeFolder = item.type;
//             fs.writeFileSync(path.join(__dirname, `../public/nft-metadata/by-name/${typeFolder}`, `${typeFolder}_${fileName}.json`), json);
//             fs.writeFileSync(path.join(__dirname, `../public/nft-metadata/by-address`, `${item.contract_address.toLowerCase()}.json`), json);
//
//         }
//     }
//
//     createJsonFiles(Characters);
//     createJsonFiles(Weapons);
//     createJsonFiles(BackSwag);
//
//     fs.writeFileSync(path.join(__dirname, `../public/nft-metadata/all-items.json`), JSON.stringify(allItems, null, 4));
// }

// processJsonFiles()